// extracted by mini-css-extract-plugin
export default {"taskId":"TaskId_taskId__MYnU5"};